/**
 * Created by PJPERF on 05.04.2017.
 */
import React from 'react';
import Button from '../../components/subcomponents/controls/button';
import FormHeader from '../../components/subcomponents/formheader';
import { connect } from 'react-redux';
import config from '../../api/config';
import notification from '../../components/subcomponents/notification';
import InputField from '../../components/subcomponents/controls/inputfield';
import ToggleField from '../../components/subcomponents/controls/togglefield';
import system from '../../api/system';
import fileDownload from 'react-file-download';
import SubformDetails from '../../components/subcomponents/subform_details';

class ConfigForm extends React.Component{
    componentWillMount() {
        config.get_config(function(err,response){

        });
        this.timer = 0;
    }
    restartSystem() {
        this.props.setSystemRestart();
        system.remote_command(
            {   type: 'system',
                command: 'system_restart'
            }, function(error,response) {
                if (error) notification.error(error.message);
            }
        );
    }
    getInfoLog() {
        config.get_log_info(function(error,response) {
            if (error) {
                notification.error(error.message);
            } else {
                fileDownload(response, 'uni_log_info.txt');
            }
        });
    }
    getErrorLog() {
        config.get_log_error(function(error,response) {
            if (error) {
                notification.error(error.message);
            } else {
                fileDownload(response, 'uni_log_error.txt');
            }
        });
    }
    sendTestEmail() {
        system.remote_command({
            type: 'system',
            command: 'send_test_email'
        },function(error,response) {
            if (!error) {
                notification.success('Test email was sent');
            } else {
                notification.error(error.message);
            }
        });
    }
    sendTestSMS() {
        system.remote_command({
            type: 'system',
            command: 'send_test_sms'
        },function(error,response) {
            if (!error) {
                notification.success('Test sms was sent');
            } else {
                notification.error(error.message);
            }
        });
    }
    createKey() {
        system.remote_command({
            type: 'system',
            command: 'create_key'
        },function(error,response) {
            if (!error) {
                notification.info('Bearer ' + response);
            } else {
                notification.error(error.message);
            }
        });
    }
    saveConfig(params) {
        let config_param = {};
        config_param[params.name] = params.value;
        config.update(config_param,function(error,response) {
            if (error) {
                console.log(error);
            }
        });
    }
    updateConfig(params){
        this.props.fieldConfigChange(params);
        this.saveConfig(params);
    }
    delayedUpdateConfig(params){
        this.props.fieldConfigChange(params);
        let self = this;
        clearTimeout (this.timer);
        this.timer = setTimeout(function(){
            self.saveConfig(params);
        }, 1000);
    }
    handleSaveConfig() {
        config.update_all(function(error, response) {
            if (error) {
                notification.error(error);
            } else {
                notification.success('Config updated');
            }
        });
    }
    render() {
        return (
            <div className="form_wrap config">
                <FormHeader title='CONFIG LIST'/>
                <span>Version: RACE EVENTS v0.0.2<br/></span>
                <span>Last reboot: {this.props.config.last_reboot}</span>
                <div className="toolbar">
                    <Button label='Restart System'  name="system_restart_button" onClick={this.restartSystem.bind(this)}/>
                    <Button label='Test Email'  name="system_email_button" onClick={this.sendTestEmail.bind(this)}/>
                </div>

                <div className="subform config_device clear">
                    <InputField name="device_name"
                                label="Device name"
                                onChange={this.delayedUpdateConfig.bind(this)} value={this.props.config.device_name}
                                maxlength={16}
                                error={this.props.config_validation['device_name']}/>
                </div>

                <div className="subform config_device clear">
                    <SubformDetails title="Notifications">
                        <div className="group_options">
                        <InputField name="email_notifications"
                            label="Emails (sep. by ',')"
                            onChange={this.delayedUpdateConfig.bind(this)} value={this.props.config.email_notifications}
                            maxlength={50}
                            error={this.props.config_validation['email_notifications']}/>
                        <InputField name="email_from_address"
                            label="Email from"
                            onChange={this.delayedUpdateConfig.bind(this)} value={this.props.config.email_from_address}
                            maxlength={50}
                            error={this.props.config_validation['email_from_address']}/>
                        </div>
                    </SubformDetails>
                </div>
                <SubformDetails title="Race settings">
                    <div className="group_options">
                        <ToggleField name="race_auto_save" label="Save race on END" onChange={this.updateConfig.bind(this)} value={this.props.config.race_auto_save}/>
                    </div>
                </SubformDetails>
                <SubformDetails title="MQTT settings">
                    <div className="group_options">
                        <ToggleField name="mqtt_on_socket" label="Send MQTT to socket" onChange={this.updateConfig.bind(this)} value={this.props.config.mqtt_on_socket}/>
                    </div>
                </SubformDetails>
                <SubformDetails title="Notifications settings">
                    <div className="group_options">
                        <ToggleField name="send_email_on_start" label="Send email on server restart" onChange={this.updateConfig.bind(this)} value={this.props.config.send_email_on_start}/>
                    </div>
                    <div className="group_options">
                        <ToggleField name="send_email_on_error" label="Send email on error" onChange={this.updateConfig.bind(this)} value={this.props.config.send_email_on_error}/>
                    </div>
                </SubformDetails>
                <SubformDetails title="Security settings">
                    <div className="group_options clear">
                        <Button label='Generate key'  name="create_key" onClick={this.createKey.bind(this)}/>
                    </div>
                </SubformDetails>
            </div>
        )
    }
}

function stateArr(obj = {}) {
    let state_arr = [];
    Object.keys(obj).forEach(field=>{state_arr.push(obj[field])});
    return state_arr;
}

function mapStateToProps(state) {
    let config = state.systemR.config_db;
    return {
        config_state: stateArr(config),
        config: config,
        config_validation: state.systemR.config_validation
    };
}

function mapDispatchToProps(dispatch) {
    return({
        setSystemRestart() {
            dispatch({
                type: "SYSTEM_RESTART",
                remote_command: {
                    type: 'system',
                    command: 'system_restart'
                }
            });
        },
        fieldConfigChange(result) {
            dispatch({
                type: "CONFIG_UPDATE_FORM",
                field: result.name,
                value: result.value
            });
        }
    })
}

export default ConfigForm = connect(
    mapStateToProps, mapDispatchToProps)(
    ConfigForm
);